import script from "./EditRuleForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditRuleForm.vue?vue&type=script&setup=true&lang=js"

import "./EditRuleForm.vue?vue&type=style&index=0&id=159284e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-159284e0"]])

export default __exports__